import { AfterContentInit, AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ClienteService } from "src/app/services/cliente.service"
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { CategoriasService } from 'src/app/services/categorias.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalFiltroAvancadoComponent } from '../modais/modal-filtro-avancado/modal-filtro-avancado.component';
import { EquipesService } from 'src/app/services/equipes.service';
import { SimpleCrypt } from 'ngx-simple-crypt';
import { BehaviorSubject, debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { ClienteEnderecoService } from 'src/app/services/cliente-endereco.service';
import { SetorPadraoService } from 'src/app/services/setor-padrao.service';
import { DeviceService } from 'src/app/services/device.service';
import { MesaTrabalhoService } from 'src/app/services/mesa-trabalho.service';
import { LocalstorageService } from 'src/app/core/localstorage/localstorage.service';
import { TokenService } from 'src/app/core/token/token.service';

@Component({
  selector: 'filtros',
  templateUrl: './filtros.component.html',
  styleUrls: ['./filtros.component.scss']
})
export class FiltrosComponent implements OnInit, AfterViewInit, AfterContentInit, OnDestroy, OnChanges {
  filtros: Object = {
    nome_filtro: ''
  };
  @Input() mostrarTotalRegistros: boolean = false;
  totalRegistros: number = 4;
  selectedTypeProjectFilter = false;
  arrayFiltrosRecebidos;
  arrayFiltrosOcultos = [];
  locale = 'pt-br';
  bsInlineValue;
  searchFilter;
  pagina = 1;
  tipoFiltroSelecionado = ""
  @Input() ticket_retidos_email
  cacheFiltro = []
  filtroCache: any = null;
  key: any;
  valor_categoria_primaria_id;
  additionalClients = [];
  newSubs: Subscription;
  filtrosKamban: boolean = false;
  maiorHora = '';
  maiorMinuto = '';
  menorHora = '';
  menorMinuto = '';
  private isDesmarcandoTodos = false;
  public emitEventToCategoriesTree: Subject<void> = new Subject<void>();
  public filtroDropdownObserver$ = new BehaviorSubject<any>({});
  @Input() tipoFiltro;
  @Input() dataClassificacao;
  @Input() isRelatorios;
  @Input() clienteId;
  @Input() dropDownFields?: [];
  @Input() set arrayFiltros(value) {
    if (this.arrayFiltrosRecebidos && !this.isRelatorios && this.tipoFiltro !== 'listagemTicketsKamban' && this.tipoFiltro !== 'listagemTickets') {
      this.cleanFilters();
    }

    if (value && value.length > 0) {
      // remove initial hidden menu option - like 'projects'
      const arrFiltered = value.filter((el: any) => !el.isHidden);
      const arrHidden = value.filter((el: any) => el.isHidden);

      this.arrayFiltrosRecebidos = arrFiltered;
      this.arrayFiltrosOcultos = arrHidden;

    } else {
      this.arrayFiltrosRecebidos = [];
    }
  }
  @Input() set ticketsKamban(value) {
    if (value) {
      this.filtrosKamban = value;
    }
  }
  @Input() isLoading: boolean = false;
  @Output() filtrosChange = new EventEmitter();
  @Output() closeParentDropdowns = new EventEmitter();
  @Output() filtrosLimpos = new EventEmitter();
  @ViewChild('selectTotalRegistros') selectTotalRegistros!: ElementRef;
  private boundHandleClick: (event: MouseEvent) => void;

  constructor(
    public translate: TranslateService,
    private elem: ElementRef,
    private renderer: Renderer2,
    private clienteService: ClienteService,
    private _localeService: BsLocaleService,
    private toastr: ToastrService,
    private categoriasService: CategoriasService,
    private modalService: NgbModal,
    private equipesService: EquipesService,
    private zone: NgZone,
    private customerAddressService: ClienteEnderecoService,
    private setorService: SetorPadraoService,
    private deviceService: DeviceService,
    private localStorageService: LocalstorageService,
    private tokenService: TokenService,
    private mesaTrabalhoService: MesaTrabalhoService,
    private cd: ChangeDetectorRef
  ) {
    this._localeService.use(this.locale);
    this.totalRegistros = localStorage.getItem('totalRegistrosUsuariosCliente') !== null ? Number(localStorage.getItem('totalRegistrosUsuariosCliente')) : 4;

    this.filtroDropdownObserver$.pipe(
      debounceTime(500), distinctUntilChanged()
    ).subscribe((dados: any) => {
      if (Object.keys(dados).length) {
        this.filtrarApi(dados.search, dados.filtro, dados.indexFiltro);
      }
    });
  }

  ngOnInit(): void {
    this.boundHandleClick = this.listenerClickOutside.bind(this);
    document.addEventListener('click', this.boundHandleClick);
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
    document.removeEventListener('click', this.boundHandleClick);
  }

  ngAfterViewInit() {
  }

  ngAfterContentInit() {
    this.setFiltroCache();
    this.getDataFromTipoFiltro();

    if ((this.tipoFiltro === 'listagemTickets' || this.tipoFiltro === 'listagemDashboardDashboard') && localStorage.getItem('additionalClients')) {
      try {
        const decoded = SimpleCrypt.decodeDefault('szHYxd7tz', localStorage.getItem('additionalClients'));
        this.additionalClients = Array.isArray(decoded) ? decoded : [];
      } catch (e) {
        this.additionalClients = [];
      }
    }

    this.zone.runOutsideAngular(() => {
      setTimeout(() => {
        if (this.tipoFiltro !== 'listagemDashboardTicket') {
          this.verificaLocalStorage();
        }
      }, 1000)
    });

    this.setSelecionadosClienteListagemTickets();
  }

  listenerClickOutside(event): void {
    var elementos = event['target'];

    if (elementos['classList'] === undefined || elementos['classList'] === undefined) {
      var _outrosDropdowns = this.elem.nativeElement.querySelectorAll('.show-dropdown-filtros');
      var _iconsOutrosDropdowns = this.elem.nativeElement.querySelectorAll('.close-dropdown-icon');

      if (_outrosDropdowns !== undefined) {
        _outrosDropdowns.forEach((drop) => {
          drop.classList.remove('show-dropdown-filtros');
        });
      }

      if (_iconsOutrosDropdowns !== undefined) {
        _iconsOutrosDropdowns.forEach((icon) => {
          icon.classList.remove('close-dropdown-icon');
        });
      }
    } else if (!elementos['classList'].contains('nome-filtro') && !elementos['classList'].contains('dropdown-opt-filtros') && !elementos['classList'].contains('text-filters') && !elementos['classList'].contains('icon-filtro') && !elementos['classList'].contains('filtro-dropdown') && !elementos['classList'].contains('time-range-input') && !elementos['id'].includes('inputText') && !elementos['id'].includes('searchDropdown') && !elementos['classList'].contains('accordion-button') && !elementos['classList'].contains('category-btn-not-child') && !elementos['classList'].contains('category-name') && !elementos['classList'].contains('search-drop-cat-multi') && !elementos['classList'].contains('opt-filtros')) {
      var _outrosDropdowns = this.elem.nativeElement.querySelectorAll('.show-dropdown-filtros');
      var _iconsOutrosDropdowns = this.elem.nativeElement.querySelectorAll('.close-dropdown-icon');

      if (_outrosDropdowns !== undefined) {
        _outrosDropdowns.forEach((drop) => {
          drop.classList.remove('show-dropdown-filtros');
        });
      }

      if (_iconsOutrosDropdowns !== undefined) {
        _iconsOutrosDropdowns.forEach((icon) => {
          icon.classList.remove('close-dropdown-icon');
        });
      }
    }
  }

  recuperarFiltros(filtroRecuperado: string) {
    if (filtroRecuperado === 'listagemDashboardTicket') {
      let filtroLocal = this.localStorageService.getStoredItemSimple('listagemDashboardTicketFiltros')
      if (filtroLocal) {
        this.filtros = filtroLocal;
        this.filtrosChange.emit(this.filtros);
        Object.keys(filtroLocal).forEach(eKey => {
          this.arrayFiltrosRecebidos.forEach(elem => {
            if (elem.model === eKey) {
              elem.selecionados = 1
            }
          })
        });

        if (this.filtros['tipo_filtro'] === '__por_mesa_trabalho__' || this.filtros['tipo_filtro'] === '__por_operador__') {
          this.tipoFiltroSelecionado = this.filtros['tipo_filtro'];
        }
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tipoFiltro'] && changes['tipoFiltro'].currentValue !== changes['tipoFiltro'].previousValue) {
      const filtroRecuperado: string = changes['tipoFiltro'].currentValue
      this.recuperarFiltros(filtroRecuperado)
    }
    if (this.isRelatorios === 17) {
      setTimeout(() => {
        this.newSubs = this.setorService
          .dropDownSetores({ cliente_id: "__all__", is_ativo: true })
          .subscribe(
            (results) => {
              var _aux = this.arrayFiltrosRecebidos
              _aux.unshift({
                nome: this.translate.instant('TIPO_RELATORIO'),
                tipo: "dropdown",
                model: "tipo_relatorio",
                data: [
                  { id: '__por_operador__', text: this.translate.instant('OPERADOR') },
                  { id: '__por_equipe__', text: this.translate.instant('EQUIPE') }
                ],
                selecionados: 0,
                concatena: false,
                multiSelect: false
              });

              _aux.push({
                nome: this.translate.instant("SETOR"),
                tipo: "dropdown",
                model: "setor",
                data: results.dropDown,
                selecionados: 0,
                concatena: true,
                multiSelect: true
              })
              this.arrayFiltrosRecebidos = _aux
            }, (error) => console.error('FiltrosChanges', error)
          );
      }, 500);
    }

    if (this.isRelatorios === 211) {
      setTimeout(() => {
        this.newSubs = this.setorService
          .dropDownSetores({ cliente_id: "__all__", is_ativo: true })
          .subscribe(
            (results) => {
              var _aux = this.arrayFiltrosRecebidos
              _aux.push({
                nome: this.translate.instant("SETOR"),
                tipo: "dropdown",
                model: "filtro_setor",
                data: results.dropDown,
                selecionados: 0,
                concatena: false,
                multiSelect: false
              })
              this.arrayFiltrosRecebidos = _aux
            }, (error) => console.error('FiltrosChanges', error)
          );
      }, 500);
    }
  }

  setSelecionadosClienteListagemTickets() {
    if (this.tipoFiltro === 'listagemTickets') {
      this.arrayFiltrosRecebidos.filter((element) => {
        if (element.model === 'cliente') {
          element.selecionados = this.filtros[element.model] ? this.filtros[element.model].length : 0
        }
      })
    }
  }

  isMesaEquipe(filtro) {
    var _aux = { cursor: 'no-drop', opacity: 0.5 };

    if ((filtro.nome === this.translate.instant('MESAS') && this.tipoFiltroSelecionado !== '__por_mesa_trabalho__') || (filtro.nome === this.translate.instant('EQUIPES') && this.tipoFiltroSelecionado !== '__por_equipes__')) {
      return _aux;
    } else {
      return null
    }
  }

  isOperadorEquipe(filtro) {
    var _aux = { cursor: 'no-drop', opacity: 0.5 };

    if ((filtro.nome === this.translate.instant('OPERADOR') && this.tipoFiltroSelecionado !== '__por_operador__') || (filtro.nome === this.translate.instant('EQUIPE') && this.tipoFiltroSelecionado !== '__por_equipe__')) {
      return _aux;
    } else {
      return null
    }
  }

  isEmpty(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop))
        return false;
    }
    return true;
  }

  desmarcarTodos(index, filtro): void {
    if (this.isDesmarcandoTodos) {
      return;
    }

    this.isDesmarcandoTodos = true;

    try {
      if (typeof (this.filtros[filtro.model]) === 'object') {
        var valoresSelecionados = (typeof (this.filtros[filtro.model]) === 'object') ? Object.assign([], this.filtros[filtro.model]) : [this.filtros[filtro.model]];
        valoresSelecionados.forEach(id => {
          this.setValorFiltro(index, id, filtro, id, true);
        });
      } else if (typeof (this.filtros[filtro.model]) === 'number') {
        this.setValorFiltro(index, this.filtros[filtro.model], filtro, this.filtros[filtro.model], true);
      } else {
        this.setValorFiltro(index, this.filtros[filtro.model], filtro, this.filtros[filtro.model], true);
      }

      filtro.selecionados = 0;

      if (filtro?.model === 'filtro_avaliacao') {
        delete filtro.valor;
        delete this.filtros[filtro.model];
      }

      if (filtro && filtro.model === 'filtro_cliente') {
        this.setDefaultValueMenuUnidade();
        let unidadeObj = this.arrayFiltrosRecebidos.find((el: any) => el.model === 'filtro_endereco_id');
        if (unidadeObj !== undefined) {
          const index = this.arrayFiltrosRecebidos.indexOf(unidadeObj);
          if (index && this.arrayFiltrosRecebidos[index]) {
            this.arrayFiltrosRecebidos[index].data = [{ id: '0', text: this.translate.instant("PRIMEIRO_SELECIONE_CLIENTE") }];
            this.arrayFiltrosRecebidos[index].showInputText = false;
          }
        }
      }
    } finally {
      this.isDesmarcandoTodos = false;
    }
  }

  setFiltroCache() {
    if (this.tipoFiltro) {
      if (this.tipoFiltro === 'listagemDashboardUsersStatus') {
        this.buildDashBoardFilters(this.tipoFiltro);
      } else {
        const localStorageItem = localStorage.getItem(this.tipoFiltro);
        if (localStorageItem) {
          let filtersRecovered = JSON.parse(JSON.stringify(SimpleCrypt.decodeDefault("szHYxd7tz", localStorageItem)));

          if (filtersRecovered) {
            if (filtersRecovered.filtro_tipo_chamado === 1) {
              this.checkIfIsTypeProjectSelected();
            }

            if (filtersRecovered.tipo_filtro && filtersRecovered.tipo_filtro !== undefined) {
              this.tipoFiltroSelecionado = filtersRecovered.tipo_filtro;
            }

            if (filtersRecovered.cliente_id === "__all__") {
              delete filtersRecovered.cliente_id;
            }

            if (filtersRecovered.cliente_id && !filtersRecovered.filtro_cliente) {
              filtersRecovered.filtro_cliente = filtersRecovered.cliente_id;
              delete filtersRecovered.cliente_id;
            } else if (filtersRecovered.cliente_id && filtersRecovered.filtro_cliente) {
              delete filtersRecovered.cliente_id;
            }

            if (this.tipoFiltro !== 'listagemDashboardDashboard') {
              delete filtersRecovered.nome_filtro;
            }

            this.removerFiltroAvaliacaoTodosDoCache(filtersRecovered);

            this.filtroCache = {
              [this.tipoFiltro]: { ...filtersRecovered }
            };
            this.filtros = { ...this.filtros, ...filtersRecovered };
          }
        }
      }
    }
  }

  buildDashBoardFilters(tipoFiltro: string) {
    const localStorageItem = localStorage.getItem(tipoFiltro);
    if (localStorageItem) {
      const listagemDashboardUsersStatus = JSON.parse(JSON.stringify(SimpleCrypt.decodeDefault("szHYxd7tz", localStorageItem)));
      if (listagemDashboardUsersStatus) {
        // del empty field
        delete listagemDashboardUsersStatus.nome_filtro;

        this.filtroCache = {
          listagemDashboardUsersStatus
        };
      }
    }
  };

  checkIfIsTypeProjectSelected() {
    this.selectedTypeProjectFilter = true;
    let projectObj = this.arrayFiltrosRecebidos.find((el: any) => el.model === 'filtro_projeto');

    if (!projectObj || projectObj === undefined) {
      const projectMenuObj = this.arrayFiltrosOcultos.find((el: any) => el.model === 'filtro_projeto');
      if (projectMenuObj) {
        projectMenuObj.selecionados = 0;
        this.arrayFiltrosRecebidos.splice(2, 0, projectMenuObj);
      }
    }
  }

  verificaLocalStorage() {
    if (!this.isEmpty(this.filtroCache)) {
      const cacheKeys = Object.keys(Object.values(this.filtroCache)[0]);
      const elementosProcessados = new Set<string>();
      for (let firstIndex = 0; firstIndex < this.arrayFiltrosRecebidos.length; firstIndex++) {
        const element = this.arrayFiltrosRecebidos[firstIndex];

        for (let secondIndex = 0; secondIndex < cacheKeys.length; secondIndex++) {
          const subelement = cacheKeys[secondIndex];

          if (subelement.includes('personalizado') && this.tipoFiltro === 'listagemDashboardDashboard') {
            this.filtros[subelement] = this.filtroCache[this.tipoFiltro][subelement];
          }

          if (Array.isArray(element.model)) {
            let listaAux = []
            for (const key in this.filtroCache) {
              for (const prop in this.filtroCache[key]) {
                var index = element.model.indexOf(prop)
                if (index > -1) {
                  listaAux.push(this.filtroCache[key][element.model[index]])
                }
              }
              if (listaAux.length === 2) {
                element.selectedDate = [new Date(listaAux[0]), new Date(listaAux[1])]
                this.setValorFiltroRangeDate(element, [new Date(listaAux[0]), new Date(listaAux[1])])
              }
            }

            this.cd.detectChanges();
          } else {
            const isMatchDireto = element.model === subelement;
            const isClienteAlternativo = (element.model === 'cliente_id' && subelement === 'filtro_cliente') ||
              (element.model === 'filtro_cliente' && subelement === 'cliente_id');
            const isCategoria = element.model === 'category' && (subelement === 'filtro_categoria_primaria' || subelement === 'filtro_categoria_secundaria');

            let cacheKey = element.model;
            let cacheValue = this.filtroCache[this.tipoFiltro][cacheKey];

            if (!isMatchDireto && isClienteAlternativo) {
              if (element.model === 'cliente_id' && this.filtroCache[this.tipoFiltro]['filtro_cliente'] !== undefined) {
                cacheKey = 'filtro_cliente';
                cacheValue = this.filtroCache[this.tipoFiltro][cacheKey];
              } else if (element.model === 'filtro_cliente' && this.filtroCache[this.tipoFiltro]['cliente_id'] !== undefined) {
                cacheKey = 'cliente_id';
                cacheValue = this.filtroCache[this.tipoFiltro][cacheKey];
              }
            } else if (isCategoria) {
              cacheKey = subelement;
              cacheValue = this.filtroCache[this.tipoFiltro][cacheKey];
            }

            const chaveProcessamento = isClienteAlternativo ? 'cliente_id_filtro_cliente' : element.model;

            if (isMatchDireto || ((isClienteAlternativo || isCategoria) && cacheValue !== undefined)) {
              if (elementosProcessados.has(chaveProcessamento)) {
                continue;
              }

              if (element.model === 'filtro_avaliacao' && (this.isRelatorios === 13 || this.isRelatorios === 26)) {
                elementosProcessados.add(chaveProcessamento);
                continue;
              }

              if (cacheValue !== undefined) {
                elementosProcessados.add(chaveProcessamento);

                if (element.model === 'filtro_avaliacao') {
                  const valoresVisiveisFiltroAvaliacao = this.obterValoresVisiveisFiltroAvaliacao(cacheValue);
                  const quantidadeSelecionadosAvaliacao = valoresVisiveisFiltroAvaliacao.length;

                  element.selecionados = quantidadeSelecionadosAvaliacao;

                  if (quantidadeSelecionadosAvaliacao === 0) {
                    delete this.filtros[element.model];
                    if (cacheKey !== element.model) {
                      delete this.filtros[cacheKey];
                    }
                    continue;
                  }

                  this.filtros[element.model] = [...valoresVisiveisFiltroAvaliacao];

                  if (cacheKey !== element.model) {
                    this.filtros[cacheKey] = [...valoresVisiveisFiltroAvaliacao];
                  }

                  for (const valorAvaliacao of valoresVisiveisFiltroAvaliacao) {
                    setTimeout(() => {
                      this.setValorFiltro(firstIndex, valorAvaliacao, element, valorAvaliacao);
                    }, 500);
                  }
                  continue;
                }

                if (Array.isArray(cacheValue)) {
                  this.filtros[element.model] = [...cacheValue];
                  element.selecionados = this.filtros[element.model].length;

                  if (cacheKey !== element.model) {
                    this.filtros[cacheKey] = [...cacheValue];
                  }

                  for (let i = 0; i < cacheValue.length; i++) {
                    const _aux = cacheValue[i];
                    setTimeout(() => {
                      this.setValorFiltro(firstIndex, _aux, element, _aux)
                    }, 500);
                  }
                } else {
                  if (typeof (cacheValue) === 'string') {
                    element.modelValue = cacheValue;
                    this.setValorFiltroInput(element, firstIndex, false);
                  } else {
                    this.filtros[element.model] = cacheValue;
                    if (cacheKey !== element.model) {
                      this.filtros[cacheKey] = cacheValue;
                    }
                    this.setValorFiltro(firstIndex, cacheValue, element, cacheValue)
                  }
                }
              }
            }

            this.cd.detectChanges();
          }
        }
      }
    }

    // Quadro do Kanban customizado tem seu próprio chip de filtro avançado e não deve herdar/sobrescrever
    // o nome_filtro salvo pela listagem de tickets (e vice-versa).
    if (this.tipoFiltro !== 'kanbanCustomizadoFiltroAvancado' && localStorage.getItem('nome_filtro')) {
      let decode: any = SimpleCrypt.decodeDefault("szHYxd7tz", localStorage.getItem("nome_filtro"));
      this.filtros['nome_filtro'] = decode;
    }
  }

  findSecondIndex(valor, lista) {
    var index = lista.findIndex((e) => {
      return e.id === valor
    })

    return index
  }

  closeOtherDropdowns(index, filtro): void {
    const _dropdown = this.elem.nativeElement.querySelector('#dd-' + index);
    const _icon = this.elem.nativeElement.querySelector('#icon-' + index);
    const _outrosDropdowns = this.elem.nativeElement.querySelectorAll('.show-dropdown-filtros');
    const _iconsOutrosDropdowns = this.elem.nativeElement.querySelectorAll('.close-dropdown-icon');

    this.closeParentDropdowns.emit(index);

    _outrosDropdowns.forEach((drop) => {
      if (drop.id !== 'dd-' + index) {
        drop.classList.remove('show-dropdown-filtros');
      }
    });

    _iconsOutrosDropdowns.forEach((icon) => {
      if (icon.id !== 'icon-' + index) {
        icon.classList.remove('close-dropdown-icon');
      }
    });

    if (filtro.tipo !== 'filtro_avancado') {
      if (_dropdown.classList.contains('show-dropdown-filtros')) {
        _dropdown.classList.remove('show-dropdown-filtros');
        _icon.classList.remove('close-dropdown-icon');
      } else {
        _dropdown.classList.add('show-dropdown-filtros')
        _icon.classList.add('close-dropdown-icon');
      }
    }
  }

  openDropdown(index, filtro): void {
    this.searchFilter = '';
    this.pagina = 1;

    if ((!this.isRelatorios || this.isRelatorios !== 17)
      && filtro.nome !== this.translate.instant('MESAS') && filtro.nome !== this.translate.instant('EQUIPES')
    ) {
      this.closeOtherDropdowns(index, filtro);
    } else if (
      (this.isRelatorios && this.isRelatorios === 17)
      && filtro.nome !== this.translate.instant('OPERADOR') && filtro.nome !== this.translate.instant('EQUIPE')
    ) {
      this.closeOtherDropdowns(index, filtro);
    } else if ((this.tipoFiltroSelecionado == '__por_mesa_trabalho__' && filtro.nome === this.translate.instant('MESAS')) || (this.tipoFiltroSelecionado == "__por_equipes__" && filtro.nome === this.translate.instant('EQUIPES'))) {
      this.closeOtherDropdowns(index, filtro);
    } else if ((this.tipoFiltroSelecionado == '__por_operador__' && filtro.nome === this.translate.instant('OPERADOR')) ||
      (this.tipoFiltroSelecionado == "__por_equipe__" && filtro.nome === this.translate.instant('EQUIPE'))) {
      this.closeOtherDropdowns(index, filtro);
    }

    if (filtro.tipo === 'input') {
      document.getElementById('inputText' + index).focus();
    } else {
      if (document.getElementById('searchDropdown' + index) !== null) {
        document.getElementById('searchDropdown' + index).focus();
      }
    }

    if (filtro.tipo === 'filtro_avancado') {
      this.openModalFiltroAvancado()
    }

    if (filtro.model === 'filtro_cliente' || filtro.model === 'cliente_id' || filtro.model === 'clientes' || filtro.model === 'cliente') {
      filtro.isRelatorios = this.isRelatorios;

      this.filtrarApi('', filtro, index);
    } else if (filtro.model === 'timezone') {
      this.filtrarApiTimezone('', filtro, index);
    } else {
      this.zone.runOutsideAngular(() => {
        setTimeout(() => {
          if (filtro.data !== undefined && filtro.tipo !== 'tree') {
            filtro.data.forEach(item => {
              item.text = this.normalizarTextoParaBuscaFiltro(item.text, filtro, item);
              if (typeof (this.filtros[filtro.model]) === 'object') {
                if (this.filtros[filtro.model].indexOf(item.id) !== -1) {
                  var _opt = this.elem.nativeElement.querySelector('#opt-' + index + '-' + item.id);
                  var verify = document.getElementsByClassName(index + '-' + item.id);
                  if (_opt && verify.length === 0 && filtro.selecionados > 0) {
                    this.adicionaCheckDropdown(index, item.id, _opt);
                  }
                }
              } else if (typeof (this.filtros[filtro.model]) === 'number' || typeof (this.filtros[filtro.model]) === 'string') {
                if (this.filtros[filtro.model] === item.id) {
                  var _opt = this.elem.nativeElement.querySelector('#opt-' + index + '-' + item.id);
                  var verify = document.getElementsByClassName(index + '-' + item.id);
                  if (_opt && verify.length === 0 && filtro.selecionados > 0) {
                    this.adicionaCheckDropdown(index, item.id, _opt);
                  }
                }
              }
            });
          }
        }, 200);
      })
    }
  }

  openModalFiltroAvancado() {
    const modalRef = this.modalService.open(ModalFiltroAvancadoComponent, {
      backdrop: "static",
      windowClass: 'modal-custom-milvus',
      keyboard: false,
      scrollable: false,
      size: "grande",
      centered: false
    });

    modalRef.result.then((result) => {
      if (result) {
        Object.keys(result).forEach(key => {
          if (key !== 'nome_filtro' && key !== 'personalizado' && !key.startsWith('personalizado-')) {
            if (result[key] && result[key].id) {
              result[key] = isNaN(parseInt(result[key].id)) ? result[key].id : parseInt(result[key].id);
            }
          }
        });

        this.filtros = result; //reseta os filtros pois filtro personalizado possui chaves únicas, concatenar misturaria os filtros

        // Quadro do Kanban customizado tem seu próprio chip de filtro avançado e não deve herdar/sobrescrever
        // o nome_filtro salvo pela listagem de tickets (e vice-versa).
        if (this.tipoFiltro !== 'kanbanCustomizadoFiltroAvancado') {
          localStorage.removeItem('nome_filtro')
          let encodedObjectAsString: string = SimpleCrypt.encodeDefault("szHYxd7tz", result.nome_filtro)
          localStorage.setItem('nome_filtro', encodedObjectAsString)
        }

        if (this.tipoFiltro === 'listagemFiltroAvancadoTickets') {
          localStorage.removeItem('listagemTickets')
          let encodedObjectAsString: string = SimpleCrypt.encodeDefault("szHYxd7tz", result)
          localStorage.setItem('listagemTickets', encodedObjectAsString)
        }

        this.sendFilters();
        this.ngAfterContentInit();

        //reseta os contadores caso algum filtro normal esteja com valor
        for (let filtro of this.arrayFiltrosRecebidos) {
          filtro.selecionados = 0;
        }
      } else {
        if (this.tipoFiltro !== 'kanbanCustomizadoFiltroAvancado') {
          localStorage.removeItem('nome_filtro')
        }
      }
    });
  }

  closeAllDropdowns(): void {
    var _outrosDropdowns = this.elem.nativeElement.querySelectorAll('.show-dropdown-filtros');
    var _iconsOutrosDropdowns = this.elem.nativeElement.querySelectorAll('.close-dropdown-icon');

    _outrosDropdowns.forEach((drop) => {
      drop.classList.remove('show-dropdown-filtros');
    });

    _iconsOutrosDropdowns.forEach((icon) => {
      icon.classList.remove('close-dropdown-icon');
    });
  }

  private preservarAcentosNoTextoExibido(filtro: any): boolean {
    return filtro?.model === 'filtro_avaliacao';
  }

  private obterValoresVisiveisFiltroAvaliacao(valorFiltroAvaliacao: any): Array<string | number> {
    if (
      valorFiltroAvaliacao === undefined ||
      valorFiltroAvaliacao === null ||
      valorFiltroAvaliacao === '' ||
      valorFiltroAvaliacao === '__all__'
    ) {
      return [];
    }

    const valoresSelecionados = Array.isArray(valorFiltroAvaliacao)
      ? valorFiltroAvaliacao
      : [valorFiltroAvaliacao];

    return valoresSelecionados.filter((valor) => valor !== '__all__');
  }

  private removerFiltroAvaliacaoTodosDoCache(filtrosRecuperados: any): void {
    if (!filtrosRecuperados || filtrosRecuperados.filtro_avaliacao === undefined) {
      return;
    }

    const valoresVisiveis = this.obterValoresVisiveisFiltroAvaliacao(
      filtrosRecuperados.filtro_avaliacao
    );

    if (valoresVisiveis.length === 0) {
      delete filtrosRecuperados.filtro_avaliacao;
      return;
    }

    filtrosRecuperados.filtro_avaliacao = valoresVisiveis;
  }

  private normalizarTextoParaBuscaFiltro(texto: string, filtro: any, item?: any): string {
    if (!texto) {
      return texto;
    }

    const textoSemAcento = texto.normalize('NFD').replace(/\p{Diacritic}/gu, '');

    if (this.preservarAcentosNoTextoExibido(filtro)) {
      if (item) {
        item.textNormalizado = textoSemAcento;
      }

      return texto;
    }

    return textoSemAcento;
  }

  adicionaCheckDropdown(firstIndex, secondIndex, _opt): void {
    var _iconSelect = this.renderer.createElement('i');
    _iconSelect.classList.add('fas', 'fa-check', 'filtro-checked-milvus', firstIndex + '-' + secondIndex);
    _iconSelect.setAttribute('style', 'color: #56ce89; position: absolute; left: 20px; margin-top: 4px;');

    if (_opt) {
      _opt.prepend(_iconSelect);
    }
  }

  removeAllCheckDropdown(data, firstIndex, secondIndex?): void {
    for (let i = 0; i < data.length; i++) {
      let id = '#opt-' + firstIndex + '-' + (secondIndex ? secondIndex : data[i].id);
      var _eachOpt = this.elem.nativeElement.querySelector(id);
      if (_eachOpt !== null && _eachOpt.childNodes.length > 1) {
        _eachOpt.removeChild(_eachOpt.childNodes[0]);
      }
    }
  }

  logicaMesaEquipes(secondIndex?, valor?): void {
    if (this.tipoFiltroSelecionado === valor) {
      this.tipoFiltroSelecionado = ''
    } else {
      this.tipoFiltroSelecionado = valor
    }

    if (this.arrayFiltrosRecebidos[5] && this.tipoFiltroSelecionado === '__por_mesa_trabalho__') {
      this.removeAllCheckDropdown(this.arrayFiltrosRecebidos[5].data, 5, secondIndex);
      this.arrayFiltrosRecebidos[5].modelValue = '';
      this.arrayFiltrosRecebidos[5].selecionados = 0;
      delete this.filtros['filtro_equipe'];
    } else if (this.arrayFiltrosRecebidos[4] && this.tipoFiltroSelecionado === '__por_equipes__') {
      this.removeAllCheckDropdown(this.arrayFiltrosRecebidos[4].data, 4, secondIndex);
      this.arrayFiltrosRecebidos[4].modelValue = '';
      this.arrayFiltrosRecebidos[4].selecionados = 0;
      delete this.filtros['filtro_mesa_trabalho'];
    }

    if (this.arrayFiltrosRecebidos[8] && this.tipoFiltroSelecionado === '__por_operador__') {
      this.removeAllCheckDropdown(this.arrayFiltrosRecebidos[8].data, 8, secondIndex);
      this.arrayFiltrosRecebidos[8].modelValue = '';
      this.arrayFiltrosRecebidos[8].selecionados = 0;
      delete this.filtros['filtro_equipe'];
    } else if (this.arrayFiltrosRecebidos[2] && this.tipoFiltroSelecionado === '__por_equipe__') {
      this.removeAllCheckDropdown(this.arrayFiltrosRecebidos[2].data, 2, secondIndex);
      this.arrayFiltrosRecebidos[2].modelValue = '';
      this.arrayFiltrosRecebidos[2].selecionados = 0;
      delete this.filtros['tecnicos'];
      delete this.filtros['filtro_tecnico'];
    }
  }

  logicaMultiSingleSelect(firstIndex?, secondIndex?, filtro?, valor?, remover?): void {
    var _opt;

    if (typeof secondIndex === 'object') {
      if (secondIndex.hasOwnProperty('model')) {
        _opt = this.elem.nativeElement.querySelector('#opt-' + firstIndex + '-' + secondIndex.model);
      }
    } else {
      _opt = this.elem.nativeElement.querySelector('#opt-' + firstIndex + '-' + secondIndex);
    }

    // if (!_opt && filtro.model === 'filtro_cliente' && filtro.data && filtro.data.length && filtro.data.at(-1).id === 'ver_mais') {
    //   const filtroClienteData = { firstIndex, secondIndex, valor };
    //   this.verMaisDropdownClientes(filtro, true, filtroClienteData);
    // }

    if (filtro.multiSelect === true) {
      if (filtro.model === 'filtro_avaliacao' && valor === '__all__') {
        return;
      }

      if (valor === '__all__' || (valor === 0 && filtro.model !== 'gravidade_id')) {
        if (this.filtros[filtro.model] === valor) {
          this.removeAllCheckDropdown(filtro.data, firstIndex, secondIndex);
          filtro.selecionados = 0;
          delete this.filtros[filtro.model];
        } else {
          this.removeAllCheckDropdown(filtro.data, firstIndex, secondIndex);
          this.adicionaCheckDropdown(firstIndex, secondIndex, _opt);
          filtro.selecionados = 1;
          this.filtros[filtro.model] = valor;
        }
      } else {
        if (_opt && _opt.childNodes.length === 1) {
          const jaEstaSelecionado = Array.isArray(this.filtros[filtro.model]) && this.filtros[filtro.model].indexOf(valor) !== -1;

          if (filtro.model && filtro.model === 'tecnico' && valor === '__sem_chatbot__') {
            if (!this.isDesmarcandoTodos) {
              this.desmarcarTodos(firstIndex, filtro);
            }
            if (this.filtros['tecnico'] && this.filtros['tecnico'].includes('__somente_chatbot__')) {
              this.filtros['tecnico'] = this.filtros['tecnico'].filter(item => item !== '__somente_chatbot__')
            }
          }

          if (filtro.model && filtro.model === 'tecnico' && valor === '__somente_chatbot__') {
            if (!this.isDesmarcandoTodos) {
              this.desmarcarTodos(firstIndex, filtro);
            }
            if (this.filtros['tecnico'] && this.filtros['tecnico'].includes('__sem_chatbot__')) {
              this.filtros['tecnico'] = this.filtros['tecnico'].filter(item => item !== '__sem_chatbot__')
            }
          }

          if (!jaEstaSelecionado) {
            this.adicionaCheckDropdown(firstIndex, secondIndex, _opt);
            filtro.selecionados++;
          } else {
            this.adicionaCheckDropdown(firstIndex, secondIndex, _opt);
          }

          if (this.filtros[filtro.model] !== '__all__' && this.filtros[filtro.model] !== 0) {
            if (filtro.concatena === true) {
              if (this.filtros[filtro.model] === undefined || typeof (this.filtros[filtro.model]) !== 'object') {
                this.filtros[filtro.model] = [valor];
              } else if (!jaEstaSelecionado) {
                this.filtros[filtro.model].push(valor);
              }
            } else {
              this.filtros[filtro.model] = valor;
            }
          }
        } else {
          if (filtro.concatena === true) {
            if (_opt !== null) {
              _opt.removeChild(_opt.childNodes[0]);
              filtro.selecionados--;
            }

            if (remover) {
              if (this.filtros[filtro.model] !== '__all__' && this.filtros[filtro.model] !== 0) {
                if (this.filtros[filtro.model] !== undefined && this.filtros[filtro.model].length > 1) {
                  const index = this.filtros[filtro.model].indexOf(valor);
                  if (index > -1) {
                    this.filtros[filtro.model].splice(index, 1);
                  }
                } else {
                  delete this.filtros[filtro.model];
                }
              }

            }
          } else {
            if (_opt !== null) {
              _opt.removeChild(_opt.childNodes[0]);
              filtro.selecionados--;
            }
            if (this.filtros[filtro.model] !== '__all__' && this.filtros[filtro.model] !== 0) {
              delete this.filtros[filtro.model];
            }
          }
        }
      }
    } else {
      if (this.filtros[filtro.model] === valor) {
        var checkIcons = this.elem.nativeElement.querySelectorAll('.filtro-checked-milvus');
        if (checkIcons.length) {
          checkIcons.forEach(icon => {
            icon.parentNode.removeChild(icon);
          });
          filtro.selecionados = 0;
          delete this.filtros[filtro.model];
        } else {
          this.adicionaCheckDropdown(firstIndex, secondIndex, _opt);
          filtro.selecionados = 1;
        }

        if (filtro.model === 'filtro_tipo_chamado' && valor === 1) {
          this.updateMenuProjetos(false);
        }
      } else {
        if (filtro.model === 'filtro_tipo_chamado' && valor === 1) {
          this.updateMenuProjetos(true);
        }

        if (filtro.model === 'filtro_tipo_chamado' && valor !== 1) {
          this.updateMenuProjetos(false);
        }

        var checkIcons = this.elem.nativeElement.querySelectorAll('.filtro-checked-milvus');
        checkIcons.forEach(icon => {
          icon.parentNode.removeChild(icon);
        });
        filtro.selecionados = 1;
        this.removeAllCheckDropdown(filtro.data, firstIndex);

        this.adicionaCheckDropdown(firstIndex, secondIndex, _opt);

        if (this.filtros[filtro.model] !== undefined) {
          if (this.filtros[filtro.model][0] === valor) {
            this.removeAllCheckDropdown(filtro.data, firstIndex);
            delete this.filtros[filtro.model];
            filtro.selecionados = 0;
          } else {
            if (this.filtros[filtro.model].length > 1) {
              const index = this.filtros[filtro.model].indexOf(valor);
              if (index > -1) {
                this.filtros[filtro.model].splice(index, 1);
              }
            } else {
              delete this.filtros[filtro.model];
              if (this.filtros[filtro.model] == undefined) {
                this.filtros[filtro.model] = valor;
              }
            }
          }
        } else {
          this.filtros[filtro.model] = valor
        }
        this.filtros[filtro.model] = valor
      }
    }

    if (filtro.model === 'filtro_cliente') {
      if (Array.isArray(this.filtros['filtro_cliente']) && this.filtros['filtro_cliente'].length > 0) {
        this.updateUnidadeNegocio();
      } else {
        this.setDefaultValueMenuUnidade();
      }
    }
  }

  updateUnidadeNegocio() {
    //lógica para popular unidade de negócio
    this.newSubs = this.customerAddressService
      .getClienteEnderecoById({ cliente_id: this.filtros['filtro_cliente'] })
      .subscribe((result) => {
        const res = (result as any)?.result || (result as any)?.results || result;
        res.dropdown?.forEach((element) => {
          let descricao = element.descricao ? element.descricao : "";
          let logradouro = element.logradouro ? ' - ' + element.logradouro : "";
          let numero = element.numero ? ", " + element.numero : "";
          let complemento = element.complemento
            ? " - " + element.complemento
            : "";
          let cep = element.cep ? " - " + element.cep : "";
          let bairro = element.bairro ? ", " + element.bairro : "";
          let cidade = element.cidade ? " - " + element.cidade : "";
          let estado = element.estado ? " - " + element.estado : "";

          element.text = descricao + logradouro + numero + complemento + cep + bairro + cidade + estado;
        });
        const unidadeObj = this.arrayFiltrosRecebidos.find((el: any) => el.model === 'filtro_endereco_id');
        if (unidadeObj !== undefined) {
          const index = this.arrayFiltrosRecebidos.indexOf(unidadeObj);
          if (index && this.arrayFiltrosRecebidos[index]) {
            this.arrayFiltrosRecebidos[index].data = result.dropdown;
            this.arrayFiltrosRecebidos[index].showInputText = true;
          }
        }
      }, (error) => console.error('updateUnidadeNegocio', error));
  }

  updateMenuProjetos(showItem: boolean): void {
    // se for tipo=projeto
    if (showItem) {
      this.checkIfIsTypeProjectSelected();
    } else {
      this.hiddenMenuProjetos();
    }
  }

  hiddenMenuProjetos() {
    this.selectedTypeProjectFilter = false;
    let projectObj = this.arrayFiltrosRecebidos.find((el: any) => el.model === 'filtro_projeto');

    if (projectObj !== undefined) {
      const index = this.arrayFiltrosRecebidos.indexOf(projectObj);
      if (index) {
        this.arrayFiltrosRecebidos.splice(index, 1);
      }
    }

    // limpa o valor do filtro de projeto
    delete this.filtros['filtro_projeto'];
  }

  setDefaultValueMenuUnidade() {
    let unidadeObj = this.arrayFiltrosRecebidos.find((el: any) => el.model === 'filtro_endereco_id');
    if (unidadeObj !== undefined) {
      const index = this.arrayFiltrosRecebidos.indexOf(unidadeObj);
      if (index && this.arrayFiltrosRecebidos[index]) {
        this.arrayFiltrosRecebidos[index].data = [{ id: '0', text: this.translate.instant("PRIMEIRO_SELECIONE_CLIENTE") }];
        this.arrayFiltrosRecebidos[index].showInputText = false;
        this.desmarcarTodos(index, this.arrayFiltrosRecebidos[index]);
      }
    }
  }

  defineCategoriaSecundaria(valor): void {
    this.newSubs = this.categoriasService.getDropDownCategoriaSecundaria({ is_ativo: true, categoria_primaria_id: valor })
      .subscribe(results => {
        switch (this.tipoFiltro) {
          case 'listagemTickets':
            if (this.arrayFiltrosRecebidos[6] && this.arrayFiltrosRecebidos[7] && this.arrayFiltrosRecebidos[6].selecionados > 0) {
              this.arrayFiltrosRecebidos[7].data = results.dropDown;

            } else if (this.arrayFiltrosRecebidos[7]) {
              this.arrayFiltrosRecebidos[7].data = [];
            }
            break;
          case 'listagemTicketsKamban':
            if (this.arrayFiltrosRecebidos[4] && this.arrayFiltrosRecebidos[5] && this.arrayFiltrosRecebidos[4].selecionados > 0) {
              this.arrayFiltrosRecebidos[5].data = results.dropDown;
            } else if (this.arrayFiltrosRecebidos[5]) {
              this.arrayFiltrosRecebidos[5].data = [];
            }
            break;
          case 'listagemModalConferenciaTickets':
            if (this.arrayFiltrosRecebidos[3]) this.arrayFiltrosRecebidos[3].data = results.dropDown;
            break;
          case 'listagemConfiguracaoSlaCategoria':
            if (this.arrayFiltrosRecebidos[1]) this.arrayFiltrosRecebidos[1].data = results.dropDown;
            break;
          case 'listagemConfiguracaoSlaCategoriaPrioridade':
            if (this.arrayFiltrosRecebidos[1]) this.arrayFiltrosRecebidos[1].data = results.dropDown;
            break;
          case 'listagemConfiguracaoSlaCategoriaCliente':
            if (this.arrayFiltrosRecebidos[2]) this.arrayFiltrosRecebidos[2].data = results.dropDown;
            break;
          case 'listagemConfiguracaoSlaCategoriaClientePrioridade':
            if (this.arrayFiltrosRecebidos[2]) this.arrayFiltrosRecebidos[2].data = results.dropDown;
            break;
          case 'listagemRelatorio':
            if (this.arrayFiltrosRecebidos[4]) this.arrayFiltrosRecebidos[4].data = results.dropDown;
            break;
          case 'listagemEditarClienteCategoria':
            if (this.arrayFiltrosRecebidos[1]) this.arrayFiltrosRecebidos[1].data = results.dropDown;
            break;
        }
      }, (error) => console.error('defineCategoriaSecundaria', error))
  }

  verificaClientesAdicionais(filtro, valor): void {
    if ((this.tipoFiltro === 'listagemDashboardDashboard' || this.tipoFiltro === 'listagemAtualizacaoAutomatica') && (filtro.model === 'cliente_id' || filtro.model === 'filtro_cliente' || filtro.model === 'clienteId')) {
      let index = filtro.data.findIndex(el => el.id === valor)
      let cliente = filtro.data[index]
      if (cliente) {
        if (this.additionalClients.length > 0) {
          let exists = this.additionalClients.findIndex(el => el.id === valor)
          if (exists === -1) {
            this.additionalClients.push(cliente)
          } else {
            this.additionalClients.splice(exists, 1)
          }
        } else {
          this.additionalClients.push(cliente)
        }
      }
    } else if (this.tipoFiltro === 'listagemTickets' && filtro.model === 'cliente') {
      let index = filtro.data.findIndex(el => el.id === valor)
      let cliente = filtro.data[index]
      if (cliente) {
        if (this.additionalClients.length > 0) {
          let exists = this.additionalClients.findIndex(el => el.id === valor)
          if (exists === -1) {
            this.additionalClients.push(cliente)
          } else {
            this.additionalClients.splice(exists, 1)
          }
        } else {
          this.additionalClients.push(cliente)
        }
      }
    }
  }

  setValorFiltro(firtsIndex?, secondIndex?, filtro?, valor?, remover?, fromView?): void {
    if (filtro?.model === 'filtro_avaliacao' && valor === '__all__') {
      return;
    }

    if (filtro && filtro.model && filtro.model === 'filtro_endereco_id' && valor === '0') {
      return;
    }

    if (valor === '__por_mesa_trabalho__' || valor === '__por_equipes__' || valor === '__por_operador__' || valor === '__por_equipe__') {
      this.logicaMesaEquipes(secondIndex, valor);
    }

    if (fromView) {
      if (this.filtros[filtro.model] !== undefined) {
        if (filtro.concatena || filtro.multiSelect) {
          if (this.filtros[filtro.model].includes(valor)) {
            this.logicaMultiSingleSelect(firtsIndex, secondIndex, filtro, valor, true);
          } else {
            this.logicaMultiSingleSelect(firtsIndex, secondIndex, filtro, valor, remover);
          }
        } else if (this.filtros[filtro.model] === valor) {
          this.logicaMultiSingleSelect(firtsIndex, secondIndex, filtro, valor, true);
        } else {
          this.logicaMultiSingleSelect(firtsIndex, secondIndex, filtro, valor, remover);
        }
      } else {
        this.logicaMultiSingleSelect(firtsIndex, secondIndex, filtro, valor, remover);
      }
    } else {
      this.logicaMultiSingleSelect(firtsIndex, secondIndex, filtro, valor, remover);
    }

    //lógica com uma variante diferente da função para mesas e equipes, por enquanto mantive aqui mesmo
    if (this.filtros[filtro.model] !== undefined) {
      if (this.arrayFiltrosRecebidos[5] && this.filtros[filtro.model][0] === '__por_mesa_trabalho__' && this.tipoFiltroSelecionado === '__por_mesa_trabalho__') {
        this.removeAllCheckDropdown(this.arrayFiltrosRecebidos[5].data, 5, secondIndex);
        this.arrayFiltrosRecebidos[5].modelValue = '';
        this.arrayFiltrosRecebidos[5].selecionados = 0;
        delete this.filtros[filtro.model];
      } else if (this.arrayFiltrosRecebidos[4] && this.filtros[filtro.model][0] === '__por_equipes__' && this.tipoFiltroSelecionado === '__por_equipes__') {
        this.removeAllCheckDropdown(this.arrayFiltrosRecebidos[4].data, 4, secondIndex);
        this.arrayFiltrosRecebidos[4].modelValue = '';
        this.arrayFiltrosRecebidos[4].selecionados = 0;
        delete this.filtros[filtro.model];
      } else if (this.arrayFiltrosRecebidos[8] && this.filtros[filtro.model][0] === '__por_operador__' && this.tipoFiltroSelecionado === '__por_operador__') {
        this.removeAllCheckDropdown(this.arrayFiltrosRecebidos[8].data, 8, secondIndex);
        this.arrayFiltrosRecebidos[8].modelValue = '';
        this.arrayFiltrosRecebidos[8].selecionados = 0;
        delete this.filtros[filtro.model];
      } else if (this.arrayFiltrosRecebidos[2] && this.filtros[filtro.model][0] === '__por_equipe__' && this.tipoFiltroSelecionado === '__por_equipe__') {
        this.removeAllCheckDropdown(this.arrayFiltrosRecebidos[2].data, 2, secondIndex);
        this.arrayFiltrosRecebidos[2].modelValue = '';
        this.arrayFiltrosRecebidos[2].selecionados = 1;
        delete this.filtros[filtro.model];
      }
    }

    // if (filtro.model && filtro.model === 'tecnico' && valor === '__sem_chatbot__') {
    //   if (this.filtros['tecnico'].includes('__somente_chatbot__')) {
    //     this.filtros['tecnico'] = this.filtros['tecnico'].filter(item => item !== '__somente_chatbot__')
    //   }
    // }

    // if (filtro.model && filtro.model === 'tecnico' && valor === '__somente_chatbot__') {
    //   if (this.filtros['tecnico'].includes('__sem_chatbot__')) {
    //     this.filtros['tecnico'] = this.filtros['tecnico'].filter(item => item !== '__sem_chatbot__')
    //   }
    // }

    //lógica para popular categoria secundária das telas
    if (filtro.model === 'filtro_categoria_primaria' || filtro.model === 'categoria_primaria_id') {
      this.defineCategoriaSecundaria(valor);
    }

    //lógica para popular grupo de dispositivos
    if (filtro.model === 'clienteId' && this.arrayFiltrosRecebidos[1] && this.tokenService.checkPermissions('@VisualizarGrupoDispositivo')) {
      this.newSubs = this.deviceService
        .getDropdownOfGroupsByCustomerId(valor)
        .subscribe((result) => {
          this.arrayFiltrosRecebidos[1].data = result.dropDown;
        }, (error) => console.error('setValorFiltro', error));
    }


    //lógica para popular dispositivos
    if (filtro.model === 'clienteId' && this.arrayFiltrosRecebidos[2]) {
      this.newSubs = this.deviceService
        .getDropdownOfLinkeds({ cliente_id: valor, is_ativo: "1" })
        .subscribe((result) => {
          this.arrayFiltrosRecebidos[2].data = result.dropDown;
        }, (error) => console.error('setValorFiltro', error));
    }

    //lógica para popular equipes
    if (filtro.model === 'filtro_equipe' && this.arrayFiltrosRecebidos[7] && this.arrayFiltrosRecebidos[7]?.data && this.arrayFiltrosRecebidos[7]?.data?.length <= 0) {
      this.newSubs = this.equipesService.getDropDownEquipes({ is_ativo: true })
        .subscribe(results => {
          this.arrayFiltrosRecebidos[7].data = results.dropDown;
        }, (error) => console.error('setValorFiltro', error))
    }

    if (filtro.model === 'filtro_mesa_trabalho' && this.arrayFiltrosRecebidos[4] && this.arrayFiltrosRecebidos[4]?.data && this.arrayFiltrosRecebidos[4]?.data?.length <= 0) {
      this.newSubs = this.mesaTrabalhoService
        .getDropDownMesas({ filtrar_mesas_tecnico: true })
        .subscribe(
          (results) => {
            this.arrayFiltrosRecebidos[4].data = results.dropDown;
            this.arrayFiltrosRecebidos[4].data.unshift({
              id: "__minhas_mesas__",
              text: this.translate.instant("MINHAS_MESAS"),
            });
            this.logicaMultiSingleSelect(firtsIndex, secondIndex, filtro, valor);
          }, (error) => console.error('setValorFiltro', error)
        );
    }

    //lógica para adicionar mais clientes em certas telas
    this.verificaClientesAdicionais(filtro, valor);

    this.verificaVisibilidade(filtro);

    // executa filtro default operadores
    if (
      (this.isRelatorios && this.isRelatorios === 17) ||
      (this.tipoFiltro === 'listagemUsuarios')
    ) {
      this.filtrosChange.emit(this.filtros);
    }
  }

  setValueFilterCategory(category_value, filter): void {
    this.filtros[filter.model] = category_value;
    filter.selecionados = (category_value) ? 1 : 0;
  }

  onInputKeypress(filtro, event): void {
    if (filtro.model === 'protocolo' && (!filtro.modelValue || filtro.modelValue.trim() === '') && event.key === ' ') {
      event.preventDefault();
      return;
    }
  }

  setValorFiltroInput(filtro, id, isOk, keypress?): void {
    if (keypress && keypress.key === 'Enter') {
      if (filtro.model === 'protocolo' && filtro.modelValue && filtro.modelValue.trim() === '') {
        return;
      }

      if (!filtro.modelValue || filtro.modelValue.trim() === '') {
        filtro.modelValue = '';
        filtro.selecionados = 0;
        delete this.filtros[filtro.model];
      } else {
        filtro.modelValue = filtro.modelValue.trim();
        filtro.selecionados = 1;
        this.filtros[filtro.model] = filtro.modelValue;
      }

      var _drop = this.elem.nativeElement.querySelector('#dd-' + id);
      var _icon = this.elem.nativeElement.querySelector('#icon-' + id);
      _drop.classList.remove('show-dropdown-filtros');
      _icon.classList.remove('close-dropdown-icon');
      this.sendFilters();
    } else {
      if (filtro.model === 'protocolo' && filtro.modelValue && filtro.modelValue.trim() === '') {
        return;
      }

      if (!filtro.modelValue || filtro.modelValue.trim() === '') {
        filtro.modelValue = '';
        filtro.selecionados = 0;
        delete this.filtros[filtro.model];
      } else {
        filtro.modelValue = filtro.modelValue.trim();
        filtro.selecionados = 1;
        this.filtros[filtro.model] = filtro.modelValue;
      }

      if (isOk === true) {
        var _drop = this.elem.nativeElement.querySelector('#dd-' + id);
        var _icon = this.elem.nativeElement.querySelector('#icon-' + id);
        _drop.classList.remove('show-dropdown-filtros');
        _icon.classList.remove('close-dropdown-icon');
        this.sendFilters();
      }
    }
  }

  setValorFiltroPesquisa(filtro): void {
    if (filtro.model === 'protocolo' && filtro.modelValue && filtro.modelValue.trim() === '') {
      return;
    }

    if (!filtro.modelValue || filtro.modelValue.trim() === '') {
      filtro.modelValue = '';
      filtro.selecionados = 0;
      delete this.filtros[filtro.model];
      this.sendFilters();
    } else {
      filtro.modelValue = filtro.modelValue.trim();
      filtro.selecionados = 1;
      this.filtros[filtro.model] = filtro.modelValue;
      this.sendFilters();
    }
  }

  setValorFiltroDate(filtro, value): void {
    if (value) {
      let formatedDate = value.getFullYear() + "-" + (value.getMonth() + 1) + "-" + value.getDate();
      filtro.modelValue = formatedDate
      this.filtros[filtro.model] = filtro.modelValue;
      filtro.selecionados = 1;
    } else {
      filtro.modelValue = null;
      this.filtros[filtro.model] = filtro.modelValue;
      filtro.selecionados = 0;
    }
  }

  setValorFiltroRangeDate(filtro, value): void {
    if (value !== null) {
      let startFormatedDate = value[0].getFullYear() + "-" + (value[0].getMonth() + 1) + "-" + value[0].getDate();
      let endFormatedDate = value[1].getFullYear() + "-" + (value[1].getMonth() + 1) + "-" + value[1].getDate();
      this.filtros[filtro.model[0]] = startFormatedDate
      this.filtros[filtro.model[1]] = endFormatedDate
      filtro.selecionados = 1;
    } else {
      this.filtros[filtro.model[0]] = null
      this.filtros[filtro.model[1]] = null
      filtro.selecionados = 0;
    }
  }

  limparFiltroRangeDate(filtro): void {
    filtro.selectedDate = null;
    filtro.selecionados = 0;
    this.setValorFiltroRangeDate(filtro, null);

    filtro.calendarioVisivel = false;
    setTimeout(() => {
      filtro.calendarioVisivel = true;
    }, 0);
  }

  cleanFilters(): void {
    localStorage.removeItem('dashboard_filtros');
    this.filtros = {};
    this.filtroCache = {};
    this.additionalClients = [];

    if (this.tipoFiltro) {
      localStorage.removeItem(this.tipoFiltro);
    }

    this.arrayFiltrosRecebidos.forEach(filtro => {
      if (filtro.modelValue) {
        filtro.modelValue = '';
      }
      if (filtro.selectedDate) {
        filtro.selectedDate = null;
      }
      if (filtro.tipo === 'date' || filtro.tipo === 'dateRange') {
        filtro.calendarioVisivel = false;
        setTimeout(() => {
          filtro.calendarioVisivel = true;
        }, 0);
      }
      if (filtro.tipo === 'timeRange') {
        filtro.maior = '';
        filtro.menor = '';
      }

      filtro.selecionados = 0;
      this.tipoFiltroSelecionado = '';

      if (filtro.tipo === 'tree') {
        this.emitEventToCategoriesTree.next();
      }

      if (filtro.hasDependecy && filtro.hasDependecy === true) {
        filtro.data = [];
      }

      if (filtro.model === 'filtro_cliente' || filtro.model === 'cliente_id' || filtro.model === 'cliente') {
        delete this.filtros[filtro.model];
      }
    });

    this.hiddenMenuProjetos();

    this.setDefaultValueMenuUnidade();

    var checkIcons = this.elem.nativeElement.querySelectorAll('.filtro-checked-milvus');
    checkIcons.forEach(icon => {
      icon.parentNode.removeChild(icon);
    });

    localStorage.removeItem('additionalClients');
    this.closeAllDropdowns();
    this.filtrosLimpos.emit();
    this.filtrosChange.emit(this.filtros);
    // Quadro do Kanban customizado tem seu próprio chip de filtro avançado e não deve herdar/sobrescrever
    // o nome_filtro salvo pela listagem de tickets (e vice-versa).
    if (this.tipoFiltro !== 'kanbanCustomizadoFiltroAvancado') {
      localStorage.removeItem('nome_filtro');
    }

    // prevent cache from dashboard to tickets list with avanced filters
    if (this.tipoFiltro === 'listagemFiltroAvancadoTickets') {
      localStorage.removeItem('listagemTickets');
    }

    if (this.tipoFiltro === 'listagemDashboardDashboard') {
      localStorage.removeItem('listagemDashboardDashboard');
    }

    //this.reloadComponent(); 
  }

  sendFilters(): void {
    this.closeAllDropdowns();

    if (this.tipoFiltro === 'listagemDashboardDashboard') {
      localStorage.removeItem('additionalClients')
      let encodedObjectAsString: string = SimpleCrypt.encodeDefault("szHYxd7tz", this.additionalClients)
      localStorage.setItem('additionalClients', encodedObjectAsString)

      if (this.filtros['cliente_id'] && !this.filtros['filtro_cliente']) {
        this.filtros['filtro_cliente'] = this.filtros['cliente_id'];
      } else if (this.filtros['filtro_cliente'] && !this.filtros['cliente_id']) {
        this.filtros['cliente_id'] = this.filtros['filtro_cliente'];
      }
    } else if (this.tipoFiltro === 'listagemTickets') {
      localStorage.removeItem('additionalClients')
      let encodedObjectAsString: string = SimpleCrypt.encodeDefault("szHYxd7tz", this.additionalClients)
      localStorage.setItem('additionalClients', encodedObjectAsString)
    }

    if (this.tipoFiltro === 'listagemFiltroAvancadoTickets' || this.tipoFiltro === 'listagemTickets') {
      if (localStorage.getItem('listagemTickets')) {
        try {
          const filtrosArmazenados: any = SimpleCrypt.decodeDefault("szHYxd7tz", localStorage.getItem('listagemTickets'));

          if (filtrosArmazenados && typeof filtrosArmazenados === 'object') {
            if (filtrosArmazenados.personalizado && Array.isArray(filtrosArmazenados.personalizado) && filtrosArmazenados.personalizado.length > 0) {
              this.filtros['personalizado'] = filtrosArmazenados.personalizado;
            }

            Object.keys(filtrosArmazenados).forEach(key => {
              if (key.startsWith('personalizado-')) {
                this.filtros[key] = filtrosArmazenados[key];
              }
            });
          }
        } catch (error) {
        }
      }

      const camposPersonalizadosEmFiltros = Object.keys(this.filtros).filter(key => key.startsWith('personalizado-'));

      if (!this.filtros['personalizado'] || !Array.isArray(this.filtros['personalizado'])) {
        if (camposPersonalizadosEmFiltros.length > 0) {
          const arrayPersonalizado = [];
          camposPersonalizadosEmFiltros.forEach(key => {
            const campoId = key.replace('personalizado-', '');
            const valor = this.filtros[key];
            if (valor && valor !== '') {
              arrayPersonalizado.push({
                id: campoId,
                valor: valor
              });
            }
          });

          if (arrayPersonalizado.length > 0) {
            this.filtros['personalizado'] = arrayPersonalizado;
          }
        }
      }
    }

    if (this.mostrarTotalRegistros) {
      this.filtros['total_registros'] = this.totalRegistros;
      if (this.tipoFiltro === 'filtroUsuariosCliente') {
        localStorage.setItem('totalRegistrosUsuariosCliente', this.totalRegistros.toString());
      }
    }

    this.filtrosChange.emit(this.filtros);
    this.salvarFiltros();
  }

  salvarFiltros() {
    if (this.tipoFiltro === 'listagemDashboardTicket') {
      this.localStorageService.storageItemSimple('listagemDashboardTicketFiltros', this.filtros)
    }
  }

  //sem uso aparentemente
  /*reloadComponent() {
    if (this.tipoFiltro === 'listagemFiltroAvancadoTickets' || this.tipoFiltro === 'listagemTickets' || this.tipoFiltro === 'listagemTicketsKamban') {
      //this.appRef.tick();      
    }
  }*/

  filtrarApiClientePaginado(search, filtro, indexFiltro): void {

    let _filtros = {};

    if (filtro.isRelatorios) {
      _filtros = { filtro_body: { is_ativo: "__all__", is_excluido: true, is_relatorio: true, filtro: search } }
    } else {
      _filtros = { filtro_body: { is_ativo: true, filtro: search } }
    }

    this.clienteService.getDropDownCliente(_filtros, { total_registros: 50 })
      .subscribe(results => {
        filtro.data = results.dropDown.lista;
        if (this.additionalClients.length > 0 && this.tipoFiltro === 'listagemAtualizacaoAutomatica') {
          this.additionalClients.forEach(el => {
            if (filtro.data.find(cliente => cliente.id === el.id)) {
              //já existe cliente no dropdown
            } else {
              filtro.data.unshift(el)
            }
          });
        }

        if (localStorage.getItem('additionalClients')) {
          let addClient: any = SimpleCrypt.decodeDefault('szHYxd7tz', localStorage.getItem('additionalClients'))
          addClient.forEach(el => {
            if (filtro.data.find(cliente => cliente.id === el.id)) {
              //já existe cliente no dropdown
            } else {
              filtro.data.push(el)
            }
          });
        }

        if (localStorage.getItem('additionalClientsListagemDispositivo')) {
          let addClient: any = SimpleCrypt.decodeDefault('szHYxd7tz', localStorage.getItem('additionalClientsListagemDispositivo'))
          addClient.forEach(el => {
            if (filtro.data.find(cliente => cliente.id === el)) {
              //já existe cliente no dropdown
            } else {
              this.newSubs = this.clienteService.getById(addClient[0]).subscribe(
                {
                  next: (result) => {
                    if (result.cliente) {
                      filtro.data.unshift({
                        "id": result.cliente.id,
                        "text": result.cliente.nome_fantasia,
                        "is_esporadico": result.cliente.is_esporadico,
                      });
                    }
                  }
                }
              )
            }
          });
        }

        if (results.dropDown.meta.paginate.last_page > 1) {
          filtro.data.push({ id: 'ver_mais', text: this.translate.instant('VER_MAIS') });
        }

        this.zone.runOutsideAngular(() => {
          setTimeout(() => {
            const filtroValue = this.filtros[filtro.model];
            const cacheValue = this.filtroCache && this.filtroCache[this.tipoFiltro] ?
              (this.filtroCache[this.tipoFiltro][filtro.model] ||
                this.filtroCache[this.tipoFiltro].cliente_id ||
                this.filtroCache[this.tipoFiltro].cliente ||
                this.filtroCache[this.tipoFiltro].filtro_cliente) : null;

            if (!filtroValue && cacheValue && filtro.selecionados > 0) {
              if (Array.isArray(cacheValue)) {
                this.filtros[filtro.model] = [...cacheValue];
                filtro.selecionados = cacheValue.length;
              } else {
                this.filtros[filtro.model] = cacheValue;
                filtro.selecionados = 1;
              }
            }

            const currentFiltroValue = this.filtros[filtro.model];

            filtro.data.forEach(item => {
              item.text = this.normalizarTextoParaBuscaFiltro(item.text, filtro, item);

              if (typeof (currentFiltroValue) === 'object' && Array.isArray(currentFiltroValue)) {
                if (currentFiltroValue.indexOf(item.id) !== -1) {
                  var _opt = this.elem.nativeElement.querySelector('#opt-' + indexFiltro + '-' + item.id);
                  var verify = document.getElementsByClassName(indexFiltro + '-' + item.id);
                  if (_opt && verify.length === 0) {
                    this.adicionaCheckDropdown(indexFiltro, item.id, _opt);
                  }
                }
              } else if (typeof (currentFiltroValue) === 'number' || typeof (currentFiltroValue) === 'string') {
                if (currentFiltroValue === item.id || currentFiltroValue === item.id.toString()) {
                  var _opt = this.elem.nativeElement.querySelector('#opt-' + indexFiltro + '-' + item.id);
                  var verify = document.getElementsByClassName(indexFiltro + '-' + item.id);
                  if (_opt && verify.length === 0) {
                    this.adicionaCheckDropdown(indexFiltro, item.id, _opt);
                  }
                }
              } else if (cacheValue && filtro.selecionados > 0) {
                if (Array.isArray(cacheValue) && cacheValue.indexOf(item.id) !== -1) {
                  if (!this.filtros[filtro.model]) {
                    this.filtros[filtro.model] = [...cacheValue];
                    filtro.selecionados = cacheValue.length;
                  }
                  var _opt = this.elem.nativeElement.querySelector('#opt-' + indexFiltro + '-' + item.id);
                  var verify = document.getElementsByClassName(indexFiltro + '-' + item.id);
                  if (_opt && verify.length === 0) {
                    this.adicionaCheckDropdown(indexFiltro, item.id, _opt);
                  }
                } else if (cacheValue === item.id || cacheValue === item.id.toString()) {
                  if (!this.filtros[filtro.model]) {
                    this.filtros[filtro.model] = cacheValue;
                    filtro.selecionados = 1;
                  }
                  var _opt = this.elem.nativeElement.querySelector('#opt-' + indexFiltro + '-' + item.id);
                  var verify = document.getElementsByClassName(indexFiltro + '-' + item.id);
                  if (_opt && verify.length === 0) {
                    this.adicionaCheckDropdown(indexFiltro, item.id, _opt);
                  }
                }
              }
            });
          }, 200);
        })
      }, (error) => console.error('filtrarApiClientePaginado', error))
  }

  filtrarApiTimezone(search, filtro, indexFiltro): void {
    this.newSubs = this.clienteService.getDropdownTimezone(search).subscribe(
      (results) => {
        const timezones = results.dropdown.map(item => {
          const valor_id = item.replace(/\//g, "-");
          return { id: valor_id, text: item }
        });

        filtro.data = timezones;

        this.zone.runOutsideAngular(() => {
          setTimeout(() => {
            this.adicionaCheckDropdown(indexFiltro, this.filtros[filtro.model], this.elem.nativeElement.querySelector('#opt-' + indexFiltro + '-' + this.filtros[filtro.model]));
          }, 100);
        });
      },
      (error) => console.error('filtrarApiTimezone', error)
    );
  }

  filtrarDropdown(search, filtro, indexFiltro): void {
    this.filtroDropdownObserver$.next({ search: search, filtro: filtro, indexFiltro: indexFiltro });
  }

  filtrarApi(search, filtro, indexFiltro): void {
    if (filtro.model === 'filtro_cliente' || filtro.model === 'cliente_id' || filtro.model === 'clientes' || filtro.model === 'cliente' || filtro.model === 'clienteId') {
      this.filtrarApiClientePaginado(search, filtro, indexFiltro);
    } else {
      //verifica itens selecionados durante a filtragem
      filtro.data.forEach(item => {
        item.text = this.normalizarTextoParaBuscaFiltro(item.text, filtro, item);
        if (typeof (this.filtros[filtro.model]) === 'object') {
          if (this.filtros[filtro.model].indexOf(item.id) !== -1) {
            var _opt = this.elem.nativeElement.querySelector('#opt-' + indexFiltro + '-' + item.id);
            var verify = document.getElementsByClassName(indexFiltro + '-' + item.id);
            if (_opt && verify.length === 0) {
              this.adicionaCheckDropdown(indexFiltro, item.id, _opt);
            }
          }
        } else if (typeof (this.filtros[filtro.model]) === 'number' || typeof (this.filtros[filtro.model]) === 'string') {
          if (this.filtros[filtro.model] === item.id) {
            var _opt = this.elem.nativeElement.querySelector('#opt-' + indexFiltro + '-' + item.id);
            var verify = document.getElementsByClassName(indexFiltro + '-' + item.id);
            if (_opt && verify.length === 0) {
              this.adicionaCheckDropdown(indexFiltro, item.id, _opt);
            }
          }
        } else if (this.isRelatorios && filtro?.valor) {
          const isItemInValor = Array.isArray(filtro.valor) ? filtro.valor.includes(item.id) : filtro.valor === item.id;
          if (isItemInValor) {
            var _opt = this.elem.nativeElement.querySelector('#opt-' + indexFiltro + '-' + item.id);
            var verify = document.getElementsByClassName(indexFiltro + '-' + item.id);
            if (_opt && verify.length === 0) {
              this.adicionaCheckDropdown(indexFiltro, item.id, _opt);
            }
          }
        }
      });
    }
  }

  verMaisDropdownClientes(filtro, isTentandoSelcionarCliente = false, filtroClienteData): void {
    this.pagina++;
    filtro.data.splice(filtro.data.length - 1, 1);
    this.newSubs = this.clienteService.getDropDownCliente({ is_ativo: true }, { total_registros: 50, pagina: this.pagina })
      .subscribe(results => {
        results.dropDown.lista.forEach(item => {
          filtro.data.push(item);
        });
        if (results.dropDown.meta.paginate.current_page !== results.dropDown.meta.paginate.last_page.toString()) {
          filtro.data.push({ id: 'ver_mais', text: this.translate.instant('VER_MAIS') });
        }

        // if (isTentandoSelcionarCliente) {
        //   const { firstIndex, secondIndex, valor } = filtroClienteData
        //   setTimeout(() => {
        //     this.logicaMultiSingleSelect(firstIndex, secondIndex, filtro, valor)
        //   }, 100)
        // }
      }, (error) => console.error('verMaisDropdownClientes', error))
  }

  setFiltroAvancadoTickets() {
    this.arrayFiltrosRecebidos = [
      { nome: this.translate.instant('FILTRO_AVANCADO'), tipo: 'filtro_avancado' },
    ]
  }

  getDataFromTipoFiltro(): void {
    switch (this.tipoFiltro) {
      case 'listagemFiltroAvancadoTickets':
        this.setFiltroAvancadoTickets();
        break;
    }
  }

  verificaFiltroRelatorioFaturamentoSinteticoAnalitico() {
    if (this.tipoFiltro === 'filtroRelatorioFaturamentoSintetico') {
      return this.arrayFiltrosRecebidos[1]?.selecionados < 1 && this.arrayFiltrosRecebidos[6]?.selecionados < 1;
    } else if (this.tipoFiltro === 'filtroRelatorioFaturamentoAnalitico') {
      return this.arrayFiltrosRecebidos[7]?.selecionados < 1 && this.arrayFiltrosRecebidos[7]?.selecionados < 1;
    } else if (this.tipoFiltro === 'listagemLicencasSoftware') {
      return !(this.arrayFiltrosRecebidos[0]?.selecionados > 0 || this.arrayFiltrosRecebidos[2]?.selecionados > 0);
    }
    return false
  }

  verificaTipoFiltro() {
    return this.tipoFiltro === 'filtroRelatorioFaturamentoAnalitico' || this.tipoFiltro === 'filtroRelatorioFaturamentoSintetico'
  }

  verificaVisibilidade(filtro): boolean {
    if (filtro.oculto) {
      return false;
    }

    if (filtro.model === 'filtro_avaliacao') {
      return this.isRelatorios === 13 || this.isRelatorios === 26;
    }

    if (this.isRelatorios) {
      switch (this.isRelatorios) {
        case 23:
          if (filtro.model !== 'clientes' && filtro.model !== 'dispositivos' && filtro.model !== 'unidade_negocio') {
            return false;
          } else {
            return true;
          }
        case 19:
          if (filtro.model === 'status' || filtro.model === 'unidade_negocio') {
            return false;
          } else {
            return true;
          }
        case 20:
          if (filtro.model === 'status') {
            return false;
          } else {
            return true;
          }
        case 14:
          if (filtro.model !== 'clientes') {
            return false;
          } else {
            return true;
          }
        case 22:
          if (filtro.model !== 'clientes' && filtro.model !== 'unidade_negocio') {
            return false;
          } else {
            return true;
          }
        case 24:
          if (filtro.model === 'dispositivos' || filtro.model === 'filtro_equipe' || filtro.model === 'tipoChamado') {
            return false;
          } else {
            return true;
          }
        case 27:
          if (filtro.model !== 'clientes' && filtro.model !== 'tecnicos' && filtro.model !== 'unidade_negocio') {
            return false;
          } else {
            return true;
          }
        case 25:
          if (filtro.model === 'tecnicos' || filtro.model === 'dispositivos' || filtro.model === 'categorias' || filtro.model === 'filtro_categoria_primaria' || filtro.model === 'filtro_equipe' || filtro.model === 'tipoChamado' || filtro.model === 'unidade_negocio') {
            return false;
          } else {
            return true;
          }
        case 17:
          if (filtro.model === 'filtro_equipe') {
            if (this.filtros['tecnicos']) {
              return false;
            } else {
              return true;
            }
          } else if (filtro.model === 'tecnicos') {
            if (this.filtros['tecnicos']) {
              return true;
            } else if (this.filtros['filtro_equipe']) {
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        case 4:
          if (filtro.model === 'unidade_negocio') {
            return false;
          } else {
            return true;
          }
        default:
          return true;
      }
    } else {
      return true;
    }
  }

  montaTooltipFila(opt) {

    let toottip = [];

    if (opt.is_normal) toottip.push("Chat");
    if (opt.is_whatsapp) toottip.push("WhatsApp");
    if (opt.is_telegram) toottip.push("Telegram");
    if (opt.is_messenger) toottip.push("Meta Messenger");

    let tooltipText = "";

    if (toottip.length > 0) tooltipText = toottip.join('/')

    return tooltipText

  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    // Permite apenas números (0-9) e teclas de controle
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  onlyNumbers(value: string): string {
    return (value || '').replace(/\D/g, '').slice(0, 2);
  }

  jumpToNext(value: string, nextInput: HTMLInputElement) {
    const clean = (value || '').replace(/\D/g, '');
    if (clean.length >= 2 && nextInput) {
      nextInput.focus();
    }
  }

  setValorFiltroTimeRange(filtro: any, id: number) {
    filtro.maior = `${this.pad2(this.maiorHora)}:${this.pad2(this.maiorMinuto)}`;
    filtro.menor = `${this.pad2(this.menorHora)}:${this.pad2(this.menorMinuto)}`;

    if (!filtro.maior && !filtro.menor) {
      this.filtros[filtro.model[0]] = null
      this.filtros[filtro.model[1]] = null
      filtro.selecionados = 0;
    } else {
      this.filtros[filtro.model[0]] = filtro.maior ? filtro.maior : null
      this.filtros[filtro.model[1]] = filtro.menor ? filtro.menor : null
      filtro.selecionados = 1;
    }

    var _drop = this.elem.nativeElement.querySelector('#dd-' + id);
    var _icon = this.elem.nativeElement.querySelector('#icon-' + id);
    _drop.classList.remove('show-dropdown-filtros');
    _icon.classList.remove('close-dropdown-icon');
    this.sendFilters();
  }

  pad2(value: string): string {
    return value.toString().padStart(2, '0');
  }


}
